import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import ChannelButton from 'components/ChannelButton';
import ConfirmBottomSheet from 'components/ConfirmBottomSheet';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { openURL } from 'utils/webViewUtils';

import { Container, CenteredImage, Header, Subheader } from '../../styles';
import {
  MobileFixedChannels,
  MobileChannelsContainer,
  DesktopChannelsContainer,
  DesktopCountryContainer,
  DesktopChannel,
  CountryName,
  LoginButton,
} from './styles';

const Help = () => {
  const { t } = useStoreTranslation();
  const [showWhatsappConfirm, setShowWhatsappConfirm] = useState<boolean>(false);
  const history = useHistory();

  const handleLoginClick = () => history.push('/corporate/login');
  const handleMailButtonClick = () => history.push('/corporate/registration/help/email');
  const handleChatButtonClick = () => setShowWhatsappConfirm(true);
  const handleChatCancel = () => setShowWhatsappConfirm(false);
  const handleChatConfirm = () => {
    openURL(`https://wa.me/${t('registrationOnboarding.help.contact.whatsappNumber')}?text=`);
    setShowWhatsappConfirm(false);
  };
  const handlePhoneButtonClick = () => openURL(`tel:+${t('registrationOnboarding.help.contact.phoneNumber')}`);

  return (
    <Container>
      <Mobile>
        <CenteredImage marginTop={25} marginBottom={50} width={160} src="/corporate/images/logo-netviajes.svg" />
      </Mobile>

      <Header black>{t('registrationOnboarding.help.title')}</Header>
      <Subheader>{t('registrationOnboarding.help.subtitle')}</Subheader>

      <Desktop>
        <DesktopChannelsContainer>
          <DesktopCountryContainer>
            <CountryName>{t('registrationOnboarding.help.countries.brazil.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('registrationOnboarding.help.countries.brazil.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('registrationOnboarding.help.countries.brazil.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>

          <DesktopCountryContainer>
            <CountryName>{t('registrationOnboarding.help.countries.colombia.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('registrationOnboarding.help.countries.colombia.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('registrationOnboarding.help.countries.colombia.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>

          <DesktopCountryContainer>
            <CountryName>{t('registrationOnboarding.help.countries.mexico.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('registrationOnboarding.help.countries.mexico.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('registrationOnboarding.help.countries.mexico.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>
        </DesktopChannelsContainer>
      </Desktop>

      <LoginButton type="button" onClick={handleLoginClick}>
        {t('registrationOnboarding.help.login')}
      </LoginButton>

      <Mobile>
        <MobileFixedChannels>
          <MobileChannelsContainer>
            <ChannelButton
              label={t('registrationOnboarding.help.contact.mail')}
              iconSrc="/corporate/images/mail-active.svg"
              onClick={handleMailButtonClick}
            />
            <ChannelButton
              label={t('registrationOnboarding.help.contact.chat')}
              iconSrc="/corporate/images/whatsapp-active.svg"
              onClick={handleChatButtonClick}
            />
            <ChannelButton
              label={t('registrationOnboarding.help.contact.phone')}
              iconSrc="/corporate/images/phone-active.svg"
              onClick={handlePhoneButtonClick}
            />
          </MobileChannelsContainer>
        </MobileFixedChannels>
      </Mobile>

      <ConfirmBottomSheet
        show={showWhatsappConfirm}
        onClose={handleChatCancel}
        onConfirm={handleChatConfirm}
        title={t('registrationOnboarding.help.contact.whatsappConfirm')}
      />
    </Container>
  );
};

export default Help;
